(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('Account', Account);

  Account.$inject = ['$resource', 'API_URI'];

  function Account($resource, API_URI) {
    return $resource(API_URI + 'api/account', {}, {
      'get': {
        method: 'GET', params: {}, isArray: false,
        interceptor: {
          response: function (response) {
            // expose response
            return response;
          }
        }
      }
    });
  }
})();
